import { render, staticRenderFns } from "./ConfigWebsiteCatalogueArticleDetailsBis.vue?vue&type=template&id=5e73660d&scoped=true"
import script from "./ConfigWebsiteCatalogueArticleDetailsBis.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueArticleDetailsBis.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueArticleDetailsBis.vue?vue&type=style&index=0&id=5e73660d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73660d",
  null
  
)

export default component.exports